import { SingleUserSplit } from './SingleUserSplit'
export default SingleUserSplit